// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"89604377","461":"0e99747e"}[chunkId] + ".chunk.js";
};